import { render, staticRenderFns } from "./FacetItem.vue?vue&type=template&id=079e5e18&"
import script from "./FacetItem.vue?vue&type=script&lang=js&"
export * from "./FacetItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports